import { useModelAnomalies } from 'models/model'
import { ModelAnomaliesContext } from './ModelAnomaliesContext'

interface ModelAnomaliesProviderProps {
  modelId: string
  children: React.ReactNode
}

export const ModelAnomaliesProvider = ({
  modelId,
  children,
}: ModelAnomaliesProviderProps): JSX.Element => {
  const { data: anomalies = [], isLoading } = useModelAnomalies(modelId)

  return (
    <ModelAnomaliesContext.Provider value={{ anomalies, isLoading }}>
      {children}
    </ModelAnomaliesContext.Provider>
  )
}
